import React from 'react';
import ErrorBoundary from '../../../../components/ErrorBoundary';
import HelpButton from '../../../../components/HelpButton';
import PbxVirtualOperator from './PbxVirtualOperator';
import { connect } from 'react-redux';
import Loading from '../../../../components/Loading';
import GlobalErrorPage from '../../../pages/GlobalErrorPage';
import PbxVirtualOperatorSettingsFestivities from './PbxVirtualOperatorSettingsFestivities';
import { fetchVirtualOperatorSettingsRequest } from '../../../../js/virtualOperator/actions';
import {
  isFetchSettingsError,
  isFetchSettingsLoaded,
} from '../../../../js/virtualOperator/selectors';
import PbxVirtualOperatorSettingsClosing from './PbxVirtualOperatorSettingsClosing';
import PbxVirtualOperatorSettingsNoCredit from './PbxVirtualOperatorSettingsNoCredit';
import { fetchTicketCategoriesRequest } from '../../../../js/tickets/actions';
import PbxVirtualOperatorSettingsTicketSettings from './PbxVirtualOperatorSettingsTicketSettings';

class PbxVirtualOperatorSettingsPage extends React.Component {
  componentDidMount() {
    const { fetchSettings, fetchTicketCategories } = this.props;
    fetchSettings();
    fetchTicketCategories();
  }

  render() {
    return (
      <PbxVirtualOperator scrolling>
        <div className="text-right">
          <HelpButton fileName="virtual-operator-settings" />
        </div>
        <ErrorBoundary>
          <React.Suspense fallback={<div />}>
            {this.props.loading ? (
              <Loading />
            ) : this.props.loadingError ? (
              <GlobalErrorPage />
            ) : (
              <React.Fragment>
                <PbxVirtualOperatorSettingsFestivities />
                <PbxVirtualOperatorSettingsClosing />
                <PbxVirtualOperatorSettingsNoCredit />
                <PbxVirtualOperatorSettingsTicketSettings />
              </React.Fragment>
            )}
          </React.Suspense>
        </ErrorBoundary>
      </PbxVirtualOperator>
    );
  }
}

function mapStateToProps(state) {
  return {
    loading: !isFetchSettingsLoaded(state),
    loadingError: isFetchSettingsError(state),
  };
}

export default connect(mapStateToProps, {
  fetchSettings: fetchVirtualOperatorSettingsRequest,
  fetchTicketCategories: fetchTicketCategoriesRequest,
})(PbxVirtualOperatorSettingsPage);
